const CLEAR_PAYLOAD = 'CLEAR_PAYLOAD'
const COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION'
const PERSIST_DATA = 'PERSIST_DATA'
const RESET_REGISTRATION = 'RESET_REGISTRATION'

// Initial state
const state = {
  payload: (JSON.parse(localStorage.getItem('registration_payload')) === null) ? {} : JSON.parse(localStorage.getItem('registration_payload')),
  complete: false
}

// Getters
const getters = {
  completeBusiness: getters => {
    const userInfo = getters.businessInformation
    let complete = true
    for (let key in userInfo) {
      if (userInfo.hasOwnProperty(key) && complete) {
        complete = !(userInfo[key] === undefined || userInfo[key] === null || userInfo[key].trim() === '' || userInfo[key] === false)
      }
    }

    return complete
  },
  completeUser: getters => {
    const userInfo = getters.userInformation
    let complete = true
    for (let key in userInfo) {
      if (userInfo.hasOwnProperty(key) && complete) {
        complete = !(userInfo[key] === undefined || userInfo[key] === null || userInfo[key].trim() === '' || userInfo[key] === false)
      }
    }

    return complete
  },
  information (state) {
    return state.payload
  },
  userInformation (state) {
    if (state.payload === {}) {
      return {}
    }
    return {
      fullName: state.payload.fullName,
      emailAddress: state.payload.emailAddress
    }
  },
  businessInformation: state => {
    return {
      clientName: state.payload.clientName,
      businessCountryCode: state.payload.businessCountryCode,
      mobileNumber: state.payload.mobileNumber
    }
  }
}

// Mutations
const mutations = {
  [CLEAR_PAYLOAD]: (state) => {
    state.payload = {}
  },

  [COMPLETE_REGISTRATION]: (state) => {
    state.complete = true
  },

  [PERSIST_DATA]: (state, payload) => {
    state.payload = payload
  },

  [RESET_REGISTRATION]: state => {
    state.complete = false
  }
}

// Actions
const actions = {
  clearMemory: ({ commit }) => {
    commit(CLEAR_PAYLOAD)
    commit(RESET_REGISTRATION)
  },

  completeRegistration: ({ commit }) => {
    commit(COMPLETE_REGISTRATION)
  },

  persist: ({ commit, state }, data) => {
    // Merge the payload with the provided data and
    // persist to local storage
    let payload = Object.assign({}, state.payload)
    Object.assign(payload, data)
    localStorage.setItem('registration_payload', JSON.stringify(payload))

    commit(PERSIST_DATA, payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/registration.js